import {
  FormContainer,
  FormTabs,
  ISelectType,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import DynamicIcon from "../../../../components/UI/DynamicIcon";
import {
  createMarComAutomationRule,
  getMarComAutomationRuleId,
  updateMarComAutomationRule,
} from "../../../../services/automationRuleMarCom.service";
import {
  automationRulesMarComSchema,
  TAutomationRulesMarComForm,
} from "./automationRulesMarComSchema";
import { BasicData } from "./BasicData/BasicData";
import { CategoriesPage } from "./Categories/CategoriesPage";
import { ClassificationsPage } from "./Classifications/ClassificationsPage";
import { ListsPage } from "./DistributionList/DistributionListPage";
import MarComTicketAutomationRulesPage from "./MarComTicketAutomationRules/MarComTicketAutomationRulesPage";
import { MessagesPage } from "./Messages/MessagesPage";
import { TimeRulesPage } from "./TimeRules/TimeRulesPage";

const translationPath = "page.4uMarCom.automationRules.";

const AutomationRulesMarCom = () => {
  const { t } = useTranslation();

  const [sendType, setSendType] = useState<ISelectType | null>(null);

  const { id } = useParams();
  const { sendRequest: save, loading: sLoading } = useFetch(
    createMarComAutomationRule
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateMarComAutomationRule
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getMarComAutomationRuleId
  );

  const saveHandler = (v: TAutomationRulesMarComForm) => {
    return save({
      ...v,
      name: v.name,
      sendTypeId: v.sendType.id,
      marComTypeId: v.marComType.id,
      campaignId: v.campaign.id,
      enable: v.enable,
    });
  };
  const updateHandler = (v: TAutomationRulesMarComForm, id: string) => {
    return update({
      item: {
        ...v,
        id: v.id,
        name: v.name,
        sendTypeId: v.sendType.id,
        marComTypeId: v.marComType.id,
        campaignId: v.campaign.id,
        enable: v.enable,
      },
      id: id,
    });
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TAutomationRulesMarComForm>> => {
      const { data, success } = await get(id);
      if (data) {
        setSendType(data.sendType);
        const newData: TAutomationRulesMarComForm = {
          ...data,
          id: data.id,
          name: data.name,
          campaign: data.campaign,
          marComType: data.marComType,
          sendType: data.sendType,
          enable: data.enable,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get]
  );

  let tabs = [
    {
      label: t(translationPath + "distribution_list"),
      icon: <DynamicIcon icon="GroupIcon" fontSize="small" />,
      component: <ListsPage />,
    },
    {
      label: t(translationPath + "classifications"),
      icon: <DynamicIcon icon="LabelOutlinedIcon" fontSize="small" />,
      component: <ClassificationsPage />,
    },
    {
      label: t(translationPath + "categories"),
      icon: <DynamicIcon icon="CategoryIcon" fontSize="small" />,
      component: <CategoriesPage />,
    },
    {
      label: t(translationPath + "messages"),
      icon: <DynamicIcon icon="ChatBubbleOutlineIcon" fontSize="small" />,
      component: <MessagesPage />,
    },
    {
      label: t(translationPath + "send_service"),
      icon: <DynamicIcon icon="SendIcon" fontSize="small" />,
      component: <MarComTicketAutomationRulesPage />,
    },
  ];
  if (sendType && sendType.code === "2") {
    tabs.push({
      label: t(translationPath + "time_rule"),
      icon: <DynamicIcon icon="ScheduleIcon" fontSize="small" />,
      component: <TimeRulesPage />,
    });
  }
  const loading = sLoading || uLoading || gLoading;

  return (
    <>
      <FormContainer<TAutomationRulesMarComForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "automation_rule")}
        schema={automationRulesMarComSchema}
        subtitle={t(translationPath + "new")}
        subtitleWatchField={"name"}
        formActionsOnBottom={false}
        marginBottom={5}
        customHeight={"fit-content"}
        fields={() => (
          <Grid container spacing={2}>
            <BasicData />
          </Grid>
        )}
      />
      {id && (
        <Grid container spacing={2} sx={{ width: "80%", margin: "0 auto" }}>
          <Grid item sm={12} mb={5}>
            <FormTabs tabs={tabs} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AutomationRulesMarCom;
